import React, { createContext } from 'react';
import MessageDialog from "../components/message";


export const MessageContext = createContext({
    isOpen: false,
    setIsOpen: () => {},
    setMessage: () => {},
    setType: () => {},
    message: {
        error: (message) => {},
        warning: (message) => {},
        info: (message) => {},
        confirm: (message, ConfirmCallbak) => {},
    },
});


export default function MessageProvider(props) {
    const [isOpen, setIsOpen] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [type, setType] = React.useState('error');
    const [confirmCallback, setConfirmCallback] = React.useState(() => {});

    const value = {
        isOpen,
        setIsOpen,
        setMessage,
        setType,
        message: {
            error: (message) => {
                setIsOpen(true);
                setMessage(message);
                setType('error');
            },
            warning: (message) => {
                setIsOpen(true);
                setMessage(message);
                setType('warning');
            },
            info: (message) => {
                setIsOpen(true);
                setMessage(message);
                setType('info');
            },
            confirm: (message, callback) => {
                setIsOpen(true);
                setMessage(message);
                setType('confirm');
                setConfirmCallback(() => { return callback});
            },
        },
    };

    return (
        <MessageContext.Provider value={value}>
            {props.children}
            <MessageDialog message={message} type={type} confirmCallback={confirmCallback} />
        </MessageContext.Provider>
    );
}
